import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../main/main.component';
import { ContactUsComponent } from './contact-us.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'contactanos',
        component: ContactUsComponent
      }
    ]
  },
];

export const ContactUsRoutes = RouterModule.forChild(routes);
